import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import ButtonCell from '@app/src/components/Table/Cells/ButtonCell'
import ValueCell from '@app/src/components/Table/Cells/ValueCell'
import ValueCellWithButton from '@app/src/components/Table/Cells/ValueCellWithButton'
import { CONFIGURATION_PAGE_IDS } from '@app/src/pages/Configurations/ConfigurationsScene'
import { SimpleOrganization } from '@app/src/types/organizations'
import paths from '@app/src/wf-constants/paths'
import AddIcon from '@mui/icons-material/Add'
import { Button, TableRow } from '@mui/material'
import React from 'react'
import { generatePath } from 'react-router'
import EditOrganizationCsmSettingsDrawer from './EditOrganizationCsmSettingsDrawer'
import { SolutionType } from '@app/src/types/resourceExplorer'
interface UserRowProps {
  row: SimpleOrganization
}

export const OrganizationRow = ({ row: organization }: UserRowProps): JSX.Element => {
  const { openDrawer, closeDrawer } = useDrawer()
  const allowedProviderScreenings = organization.setting?.allowedProviderScreenings

  return (
    <TableRow>
      <ValueCell value={organization.id} />
      <ButtonCell
        to={generatePath(paths.configurations, {
          configurationsPage: CONFIGURATION_PAGE_IDS.Organizations,
          configurationsSubPage: organization.id,
        })}
        label={`${organization.name}`}
      />
      <ValueCell value={organization.vatNumber} />
      <ValueCell value={organization.websiteAddress} />
      <ValueCell value={organization.setting?.solutionType} />
      <ValueCellWithButton
        value={allowedProviderScreenings}
        actionButton={
          <Button
            startIcon={<AddIcon />}
            onClick={() => {
              openDrawer(<EditOrganizationCsmSettingsDrawer closeDrawer={closeDrawer} organization={organization} />, {
                showAboveDialogs: true,
              })
            }}
            variant="outlined"
            disabled={organization.setting?.solutionType === SolutionType.Transparency}
          >
            Add
          </Button>
        }
      />
    </TableRow>
  )
}

export default OrganizationRow
